module.exports = __webpack_public_path__ + "static/crm-c3eceaab0f2c8afec568b3bc4be4d1bc.jpg";